/**
 * @flow
 * @relayHash 92a1b6dcf684b2f4b4e27edc3f9e1c50
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GenerateFotoFlatZipInput = {|
  eventId: string,
  startnumber?: ?string,
  variant: string,
|};
export type GenerateFotoFlatZipMutationVariables = {|
  input: GenerateFotoFlatZipInput
|};
export type GenerateFotoFlatZipMutationResponse = {|
  +generateFotoFlatZip: ?{|
    +url: ?string
  |}
|};
export type GenerateFotoFlatZipMutation = {|
  variables: GenerateFotoFlatZipMutationVariables,
  response: GenerateFotoFlatZipMutationResponse,
|};
*/


/*
mutation GenerateFotoFlatZipMutation(
  $input: GenerateFotoFlatZipInput!
) {
  generateFotoFlatZip(input: $input) {
    url
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "GenerateFotoFlatZipInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "generateFotoFlatZip",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateFotoFlatZipPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GenerateFotoFlatZipMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GenerateFotoFlatZipMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "GenerateFotoFlatZipMutation",
    "id": null,
    "text": "mutation GenerateFotoFlatZipMutation(\n  $input: GenerateFotoFlatZipInput!\n) {\n  generateFotoFlatZip(input: $input) {\n    url\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '925b8a5dc7428be366fabdd3b29f3cfa';

module.exports = node;
